module.exports = __webpack_public_path__ + "media/images/flags/16/Afghanistan-0cf2d6bd027ed1f801b7bb9076df63ca.png";